import React, { Component } from 'react'
import '../styles/Booking.css'
import '../styles/Navbar.css'
import BookingContainer from './BookingContainer'
import MagnifierIcon from '../images/icons/magnifier.png'
import FAQPattern from '../images/FAQ/FAQpattern.png'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { Helmet } from 'react-helmet'
import MobileMenu from './MobileMenu'
import BurgerIcon from '../images/Navbar/burger.png'
import NavbarItem from './NavbarItem'

const bookingStyle = {
  alignItems: "center"
}

class Booking extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sidebarRight: "-344px",
      popInDisplay: "none",
      sidebarOpacity: "0",
      mobileMenu: false,
      prices: ""
    }

    const list = [2, 3, 4, 5, 6];
    this.props.getPrices(list, true).then((output) => {
      this.setState({ prices: output });
    })
    .catch((e) => {
      console.error(e);
    });
  }

  toggleSidebar = () => {
    if (this.state.sidebarRight === "-344px") {
      this.setState({
        sidebarRight: "0",
        popInDisplay: "inline",
        sidebarOpacity: "1" })
    } else {
      this.setState({
        sidebarRight: "-344px",
        popInDisplay: "none",
        sidebarOpacity: "0" })
    }
  }

  toggleMobileMenu = () => {
    const menu = document.getElementById("mobile-menu-overlay")
    if (!this.state.mobileMenu) {
      this.setState({ mobileMenu: true })
      menu.style.display = "inline-block"
      window.setTimeout(x => {
        menu.style.opacity = 1
      }, 10)
    } else {
      menu.style.opacity = 0
      window.setTimeout(x => {
        menu.style.display = "none"
      }, 300)
      this.setState({ mobileMenu: false})
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="booking">
      <Helmet>
        <title>{formatMessage(messages.metaTitle)}</title>
        <meta name="description" content="Réserver directement votre escape game à Paris sur notre calendrier de réservation"/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content="https://www.one-hour.fr/reserver/"/>
        <meta property="og:title" content="Réservation - One Hour"/>
        <meta property="og:description" content="Réserver directement votre escape game à Paris sur notre calendrier de réservation"/>
        <meta property="og:image" content="https://www.one-hour.fr/static/media/la-cover.83020b54.jpg"/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content="https://www.one-hour.fr/reserver/"/>
        <meta property="twitter:title" content="Réservation - One Hour"/>
        <meta property="twitter:description" content="Réserver directement votre escape game à Paris sur notre calendrier de réservation"/>
        <meta property="twitter:image" content="https://www.one-hour.fr/static/media/la-cover.83020b54.jpg"/>
        <html lang="fr" />
      </Helmet>
      <div
        className="navbar navbar-sticky navbar-booking"
        style={this.state.mobileMenu ? {} : bookingStyle}>
        <div className="logo-container">
        <Link to="/">
          <div className="logo" style={{ padding: 0 }}>
            <img className="magnifier" src={MagnifierIcon} alt="magnifier-icon"/>
            <div className="logo-text">
            <div className="one-hour-title">one hour</div>
            <div className="one-hour-baseline">Escape Game</div>
            </div>
          </div>
          <div className="logo-go-back--hidden">
            {formatMessage(messages.goBack)}
          </div>
        </Link>
        </div>

        {
        !this.state.mobileMenu
        ? <h1>{formatMessage(messages.title)}</h1>
        : null
        }
        {
        this.state.mobileMenu
        ?
        <div className="navigation-right-lang navigation-right-lang-mobile">
          <div onClick={(lang) => this.props.handleLang("en")}>
          <NavbarItem lang={this.props.lang} title="EN" />
          </div> |
          <div onClick={(lang) => this.props.handleLang("fr")}>
          <NavbarItem lang={this.props.lang} title="FR"/>
          </div>
          <div className="close" onClick={() => this.toggleMobileMenu()}/>
        </div>
            : <img className="navbar-burger" alt="burger" src={BurgerIcon} onClick={() => this.toggleMobileMenu()}/>
          }
          <div
            className="booking-pricing"
            onClick={this.toggleSidebar.bind(this)}
            >
            <span>{formatMessage(messages.pricing)}</span><span className="question-mark--booking">?</span>
          </div>
        </div>
        <BookingContainer
          noTitle={true}
          expiration={() => this.props.handleExpiration()}
          handleSidebar={() => this.toggleSidebar()}
          lang={this.props.lang} />
		  <ul id="passculture">
			<li>
			{formatMessage(messages.passculturetxt1)}
			</li>
			<li>
			{formatMessage(messages.passculturetxt2)}
			</li>
			<li>
			{formatMessage(messages.passculturetxt3)}
			</li>
			<li>
			{formatMessage(messages.passculturetxt4)}
			</li>
		  </ul>
        <div
          className="pop-in"
          style={{ display: `${this.state.popInDisplay}`}}
          onClick={() => this.toggleSidebar()}
          ></div>
        <div
          className="sidebar"
          style={{
            right: `${this.state.sidebarRight}`,
            opacity: `${this.state.sidebarOpacity}`,
          }}
          >
          <div className="sidebar-header">
            <span
              className="sidebar-close-button"
              onClick={this.toggleSidebar.bind(this)}
              ></span>
            <p>{formatMessage(messages.pricingTitle)}</p>
          </div>
          <div className="sidebar-ribbon">
            <div
              className="sidebar-ribbon-pattern"
              style={{ backgroundImage: `url(${FAQPattern})`}}
            ></div>
            <p><b>{formatMessage(messages.pricingIntroBold)}</b> {formatMessage(messages.pricingIntroNormal)}</p>
          </div>
          <div className="sidebar-box">
            <h4>
              {formatMessage(messages.pricingFullHours)}
            </h4>
            <p className="sidbar-box-text" dangerouslySetInnerHTML={{ __html: this.state.prices }}></p>
          </div>
          <div className="sidebar-box">
            <h4>
              {formatMessage(messages.pricingFullHours4)}
            </h4>
            <p className="sidbar-box-text">{formatMessage(messages.pricingFullHours5)}</p>
          </div>
          <div className="sidebar-box">
          </div>
        </div>
        <MobileMenu />
      </div>
    );
  }
}

const messages = defineMessages({
  metaTitle: {
    id: 'booking.metaTitle',
    defaultMessage: 'Réservation escape game Paris - One Hour'
  },
  title: {
    id: 'booking.title',
    defaultMessage: 'Réservation'
  },
  pricing: {
    id: 'booking.pricing',
    defaultMessage: 'Tarifs'
  },
  pricingTitle: {
    id: 'booking.pricingTitle',
    defaultMessage: 'Les tarifs'
  },
  pricingIntroBold: {
    id: 'booking.pricingIntroBold',
    defaultMessage: 'Nos tarifs dépendent de deux facteurs :'
  },
  pricingIntroNormal: {
    id: 'booking.pricingIntroNormal',
    defaultMessage: 'le nombre de joueurs dans l’équipe et le créneau horaire (heure creuse ou heure pleine).'
  },
  pricingFullHours: {
    id: 'booking.pricingFullHours',
    defaultMessage: 'PRIX HEURES PLEINES'
  },
  pricingDiscountHours: {
    id: 'booking.pricingDiscountHours',
    defaultMessage: 'PRIX HEURES CREUSES'
  },
  pricingFullHoursDescription: {
    id: 'booking.pricingFullHoursDescription',
    defaultMessage: '(Heures pleines : de 18h à 22h en semaine et de 10h à 22h le week-end & jours fériés/vacances)'
  },
  pricingDiscountHoursDescription: {
    id: 'booking.pricingDiscountHoursDescription',
    defaultMessage: '(10h-16h du lundi au vendredi)'
  },
  pricingFullHours5: {
    id: 'booking.pricingFullHours5',
    defaultMessage: '- Equipe de 5 - 22€ / joueur'
  },
  pricingFullHours4: {
    id: 'booking.pricingFullHours4',
    defaultMessage: '- Equipe de 4 - 25€ / joueur'
  },
  pricingFullHours3: {
    id: 'booking.pricingFullHours3',
    defaultMessage: '- Equipe de 3 - 30€ / joueur'
  },
  pricingDiscountHours5: {
    id: 'booking.pricingDiscountHours5',
    defaultMessage: '- Equipe de 5 - 22€ / joueur'
  },
  pricingDiscountHours4: {
    id: 'booking.pricingDiscountHours4',
    defaultMessage: '- Equipe de 4 - 25€ / joueur'
  },
  pricingDiscountHours3: {
    id: 'booking.pricingDiscountHours3',
    defaultMessage: '- Equipe de 3 - 30€ / joueur'
  },
  passculturetxt1: {
    id: 'booking.passculturetxt1',
    defaultMessage: 'L’âge minimum pour participer à une session chez One Hour est de 14 ans.'
  },
  passculturetxt2: {
    id: 'booking.passculturetxt2',
    defaultMessage: 'Toutes les réservations et paiements s’effectuent exclusivement en ligne par carte bancaire, chèque-vacances connect ou pass culture.'
  },
  passculturetxt3: {
    id: 'booking.passculturetxt3',
    defaultMessage: 'L’Expédition Maudite, Mission Yakuza et Very Bad Night sont jouables à 6 mais nous conseillons de faire des équipes de 2 à 5 joueurs.'
  },
  passculturetxt4: {
    id: 'booking.passculturetxt4',
    defaultMessage: '⚠️ À 6 le jeu sera moins intense et confortable.'
  },
  passculture: {
    id: 'booking.passculture',
    defaultMessage: 'pass culture'
  },
  goBack: {
    id: 'navbar.goBack',
    defaultMessage: "Revenir sur le site"
  }
})

export default injectIntl(Booking)



// WEBPACK FOOTER //
// ./src/components/Booking.js